import { faAt, faPhone } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import CustomLink from "shared/ui/typography/CustomLink";
import Heading from "shared/ui/typography/Heading";
import Text from "shared/ui/typography/Text";

export const AlreadyPlannedHeader = () => {
  return (
    <header className="gg-col-span-12 gg-mb-10 lg:gg-col-span-4 lg:gg-mb-0 lg:gg-pr-10 xl:gg-pr-24">
      <Heading headingLevel="h2" className="gg-mb-1 gg-text-2xl">
        Leveringsafspraak al bevestigd
      </Heading>
      <Text className="gg-pt-2">
        Je levering is succesvol ingepland en staat in onze planning. Je hoeft
        niets meer te doen — we zorgen dat alles op tijd bij je aankomt.
      </Text>

      <div className="gg-pt-4">
        <p>
          {" "}
          Heb je nog vragen of wil je iets wijzigen? Neem dan gerust contact met
          ons op:
        </p>
        <div className="gg-mt-1 gg-flex gg-flex-col gg-space-y-1">
          <CustomLink
            className="gg-flex gg-items-center gg-gap-x-1.5 hover:gg-text-gray-500"
            to="mailto:info@gewoongers.nl"
            opacityTransition={false}
          >
            <FontAwesomeIcon icon={faAt} size="sm" />
            info@gewoongers.nl
          </CustomLink>
          <CustomLink
            className="gg-flex gg-items-center gg-gap-x-1.5 hover:gg-text-gray-500"
            to="tel:+310103072889"
            opacityTransition={false}
          >
            <FontAwesomeIcon icon={faPhone} size="sm" /> 010 3072889
          </CustomLink>
        </div>
      </div>
    </header>
  );
};
